import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  defaultValue?: Option;
  className?: string;
  styles?: any;
  param?: string; 
  setData?: (data: any) => void; 
}

const CommonSelect: React.FC<SelectProps> = ({
  options,
  defaultValue,
  className,
  setData,
  param,
}) => {
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(defaultValue);

  useEffect(() => {
    setSelectedOption(defaultValue || undefined);
  }, [defaultValue]);

  const handleChange = (e: Option | null) => {
    if (e && setData && param) {
      setData((prevData: any) => ({
        ...prevData,
        [param]: e.value, 
      }));
      setSelectedOption(e); 
    }
  };

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      options={options}
      value={selectedOption}
      placeholder="Select"
      onChange={handleChange}
      required
    />
  );
};

export default CommonSelect;
